var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader",style:({ color: 'rgba(0, 0, 0, 0.54)'   })},[_c('span',{staticClass:"dot"}),_vm._v(" "),_c('span',{staticClass:"dot"}),_vm._v(" "),_c('span',{staticClass:"dot"})])
}
var staticRenderFns = []

export { render, staticRenderFns }